// @flow
import type { Dispatch } from 'redux';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { setError } from './../error/actions';

function setLiveEvents(contents: Array<Object>) {
  return {
    type: 'SET_LIVE_EVENTS',
    contents
  };
}
function setLiveEventsFetchingStatus(fetching: boolean) {
  return {
    type: 'SET_LIVE_EVENTS_FETCHING_STATUS',
    fetching
  };
}

export function getLiveEvents() {
  return function (dispatch: Dispatch) {
    dispatch(setLiveEventsFetchingStatus(true));

    return finectAPI({
      version: 'v4',
      path: `contents/events`,
      method: 'GET',
      onSuccess: ({ data }: { data: Object }) => {
        dispatch(setLiveEvents(data));
      },
      onError: () => {
        Promise.all([dispatch(setError({ code: 404, message: 'Error al cargar los eventos' }))]);
      }
    });
  };
}
